var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowReview(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.2581,
    cy: 9.5,
    r: 9.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.58597 12.0592C8.2823 12.3626 8.2823 12.855 8.58597 13.1583C8.73778 13.3101 8.93663 13.386 9.1355 13.386C9.33441 13.386 9.53322 13.3101 9.68503 13.1583L12.7941 10.0492C13.0978 9.74584 13.0978 9.25348 12.7941 8.9501L9.68503 5.84104C9.38136 5.53736 8.88954 5.53736 8.58591 5.84104C8.28224 6.14442 8.28224 6.63678 8.58591 6.94016L11.1453 9.49974L8.58597 12.0592Z",
    fill: "#21314B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowReview);
export default __webpack_public_path__ + "static/media/ArrowReview.f7bd55625b697f168e40cd7f6acdd8e9.svg";
export { ForwardRef as ReactComponent };